export default {
  loading: {
    text: "拼命加载中",
  },
  title: "地址转账情况",
  subtitle: "数据统计币种：",
  dialogTitle: "地址转账情况",
  empty: "暂无数据",
  filters: {
    currency: "币种",
    selectCurrency: "请选择币种",
  },
  types: {
    transactionAmount: "交易数量",
    transactionCount: "交易次数",
  },
  units: {
    amount: "金额",
    times: "次数",
  },
  actions: {
    enlarge: "放大查看",
  },
};
